import service from "@/utils/request";
// 微信模板列表
export const getWechatTemplateApi = () => {
  return service({
    url: "/api/v1/wechat/template/list",
    method: "get",
  });
};

// 开关微信模板
interface toggleTemplateData {
  is_open: number;
  template_message_id: number;
}
export const toggleTemplateApi = (data: toggleTemplateData) => {
  return service({
    url: "/api/v1/wechat/template/set_open",
    method: "post",
    data,
  });
};
